import { motion } from "framer-motion";
import { Phone, HandHeart } from "lucide-react";

export default function Volunteer({ onNavigate }) {
  return (
    <section id="volunteer" className="relative bg-navy noise py-24 md:py-32 px-5 md:px-10 overflow-hidden" data-testid="volunteer-section">
      <div className="max-w-5xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="flex justify-center mb-6"
        >
          <HandHeart className="w-10 h-10 text-gold" strokeWidth={1.5} />
        </motion.div>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-xs uppercase tracking-[0.3em] font-semibold text-gold mb-6"
        >
          Volunteer
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-[#F8F9FA] leading-[1.05]"
        >
          This campaign runs
          <span className="block italic font-medium text-white/85">on people like you.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.18 }}
          className="text-white/90 text-base md:text-lg leading-relaxed mt-8 max-w-2xl mx-auto"
        >
          Knock doors, make calls, put up a yard sign, or drive an elder to the polls. And if you'd rather
          talk to a person — call Dave directly. He's happy to hear from you, whether you want to volunteer
          or request a personal meeting.
        </motion.p>

        <motion.a
          href="tel:4210970"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
          className="group inline-flex flex-col items-center mt-12 border border-white/15 bg-white/5 backdrop-blur-sm rounded-sm px-10 md:px-16 py-8 md:py-10 hover:bg-white/10 hover:border-gold/40 transition-all duration-300"
          data-testid="volunteer-call-link"
          aria-label="Call Dave at 421-0970 to volunteer or request a personal meeting"
        >
          <span className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] font-semibold text-gold mb-4">
            <Phone className="w-4 h-4" /> Call Dave directly
          </span>
          <span className="font-serif text-5xl sm:text-6xl md:text-7xl font-black tracking-tight text-gold group-hover:text-[#F8F9FA] transition-colors duration-300 tabular-nums">
            421-0970
          </span>
          <span className="text-sm text-gold mt-4">
            To volunteer — or to request a personal meeting with Dave
          </span>
        </motion.a>
      </div>
    </section>
  );
}
